import React from "react";

export default function Module_1() {
    return (
        <h1 className="text-uppercase">
            About Us
            <br />
            <span className="fs-3 fw-bold">and our passion for lighting</span>
        </h1>
    );
}
